import { sort } from "semver"

const badgeFn = {

}

/**
 * 计算徽章类型对徽章的筛选结果，添加徽章的图片path路径
 * arr:当前徽章数组
 * sortArr:徽章类型数组
 */
badgeFn.calcSort = function (arr, sortArr) { 
    let finalArr = []
    if (arr instanceof Array && sortArr instanceof Array) {
        arr.forEach(item => { 
            let imgs = []
            if (item.sort && item.sort.length != 0) {
                // 筛选
                const filter1 = item['sort'];
                const filter2 = sortArr
                const filterFinal = filter1.filter(val => 
                    filter2.some(itemC => itemC['en'] === val)
                );
                filterFinal.forEach(itemC => {
                    let obj = {}
                    obj['path'] = itemC + "/" + item['en']
                    imgs.push(obj)
                })
            }
            item['imgs'] = imgs
            if (item['imgs'].length != 0) { 
                finalArr.push(item)
            }
        })
    }
    return finalArr
}

/**
 * 计算徽章颜色对徽章的筛选结果，添加徽章的颜色path路径
 * arr:当前徽章数组 
 * colorArr:当前颜色数组 
 */
badgeFn.calcColors = function (arr, colorArr) { 
    let finalArr = []
    if (arr instanceof Array && colorArr instanceof Array) { 
        arr.forEach(item => { 
            let colors = []
            if (item.color && item.color.length != 0) { 
                // 筛选
                const filter1 = item['color'];
                const filter2 = colorArr
                const filterFinal = filter1.filter(val => 
                    filter2.some(itemC => itemC['en'] === val)
                );
                filterFinal.forEach(itemC => {
                    let obj = {}
                    obj['path'] = 'badgeType/' + itemC
                    colors.push(obj)
                })
            }
            item['colors'] = colors
            if (item['colors'].length != 0) { 
                finalArr.push(item)
            }
        })
    }
    return finalArr
}

/**
 * 计算徽章属性对徽章的筛选结果，必须先执行计算徽章类型对徽章的筛选结果后再执行此方法
 * arr:当前徽章数组
 * attrArr:当前属性数组
 * allAttrArr:所有属性数组
 * isFilter:是否筛选负属性，1表示筛选，2表示不筛选
 */
badgeFn.calcAttr = function (arr, attrArr, allAttrArr, isFilter) {
    let finalArr = []
    if (arr instanceof Array && attrArr instanceof Array && allAttrArr instanceof Array) { 
        let attrLen = attrArr.length
        let allAttrLen = allAttrArr.length
        arr.forEach(item => { 
            let attrs = {}
            if (item.attr && item.sort && item.sort.length != 0) { 
                const sortArr = item['sort'];
                // 判断是否要筛选负属性
                if ((attrLen != allAttrLen) && isFilter == '1') {
                    // 处理百变怪无属性的问题
                    if (item['en'] == 'Ditto') {

                    } else { 
                        // 判断是否有相对应的属性，有的话才赋予
                        let hasPropertyInfo = true
                        sortArr.forEach(itemC => {
                            // 判断是否有相对应的属性，有的话才赋予
                            attrArr.forEach(itemG => { 
                                let str = itemG['en']
                                if (item.attr[itemC][str] && item.attr[itemC][str].indexOf('-') != '-1') { 
                                    hasPropertyInfo = false
                                }
                            })
                        })
                        if (hasPropertyInfo) { 
                            sortArr.forEach(itemC => { 
                                attrArr.forEach(itemG => { 
                                    let str = itemG['en']
                                    if (item.attr[itemC][str]) { 
                                        attrs[itemC] = item.attr[itemC]
                                    }
                                })
                            })
                        }
                    }
                } else { 
                    sortArr.forEach(itemC => {
                        // 判断是否有相对应的属性，有的话才赋予
                        let hasPropertyInfo = false
                        attrArr.forEach(itemG => { 
                            let str = itemG['en']
                            
                            if (item.attr[itemC][str]) { 
                                hasPropertyInfo = true
                            }
                        })
                        if (hasPropertyInfo) { 
                            attrs[itemC] = item.attr[itemC]
                        }
                    })
                }
            }
            item['attrs'] = attrs
            // 处理百变怪无属性的问题
            if (item['en'] == 'Ditto' && (attrLen == allAttrLen)) { 
                attrs = {}
                attrs['Bronze'] = {}
                attrs['Silver'] = {}
                attrs['Gold'] = {}
                attrs['platinum'] = {}
                item['attrs'] = attrs
                finalArr.push(item)
            } else if (JSON.stringify(item['attrs']) != "{}") { 
                finalArr.push(item)
            }
        })
    }
    return finalArr
}

/**
 * 将徽章做成自己想要的格式，返回想要的格式
 * arr:当前徽章数组
 */
badgeFn.ownList = function (arr,sortArr) { 
    let finalArr = []
    if (arr && arr instanceof Array) { 
        arr.forEach(item => {
            item.info = []
            if (item['en'] == 'Ditto') { 
                
            }
            if (item.sort && item.sort.length != 0) {
                sortArr.forEach((itemC, indexC) => {
                    let infoObj = {}
                    item['imgs'].forEach(itemG => { 
                        if (itemG['path'].indexOf(itemC['en']) != -1) { 
                            infoObj['type'] = itemC
                            infoObj['attr'] = item['attrs'][itemC['en']]
                            infoObj['path'] = itemG['path']
                            infoObj['zh'] = item['zh']
                            infoObj['en'] = item['en']
                            infoObj['colors'] = item['colors']
                            infoObj['color'] = item['color']
                            item.info.push(infoObj)
                            finalArr.push(infoObj)
                        }
                    })
                })
            } 
        })
    }
    return finalArr
}
/**
 * 计算配置徽章的属性
 * arr:组合徽章的数组
 * colorArr:所有颜色数组 
 */
badgeFn.calcCombinationAttr = function (arr,colorArr) { 
    let finalObj = []
    // 颜色数组数量提供的额外属性对象
    let colorsObj = {}
    // 排除相同名称宝可梦后的数组（宝可梦名称一致提供额外属性时，只算一个）
    let pokemonArr = []
    if (arr && arr instanceof Array && colorArr && colorArr instanceof Array) { 
        arr.forEach((item, index) => {
            if (index == 0) {
                let obj = {
                    color: item['color'],
                    en:item['en']
                }
                pokemonArr.push(obj)
            } else { 
                let result = true
                pokemonArr.forEach(itemC => { 
                    if (itemC['en'] == item['en']) { 
                        result = false
                    }
                })
                if (result) { 
                    let obj = {
                        color: item['color'],
                        en:item['en']
                    }
                    pokemonArr.push(obj)
                }
            }
        })
        // 计算颜色带来的额外属性
        pokemonArr.forEach(item => { 
            if (item['color'] && item['color'].length != 0) { 
                item['color'].forEach(itemC => { 
                    if (colorsObj[itemC]) {
                        colorsObj[itemC]['number'] ++
                    } else { 
                        colorsObj[itemC] = {}
                        colorsObj[itemC]['number'] = 1
                    }
                })
            }
        })
        // 计算属性最终值
        let arrCurrent = JSON.parse(JSON.stringify(arr))
        let arr1 = []
        arrCurrent.forEach(item => { 
            if (item['attr']) { 
                arr1.push(item['attr'])
            }
        })
        let attrObj = {}
        arr1.forEach(item => { 
            Object.keys(item).forEach((i, v)=> { 
                if (attrObj[i]) {
                    attrObj[i] = String((Number(attrObj[i]) + Number(item[i])).toFixed(2))
                } else { 
                    attrObj[i] = {}
                    attrObj[i] = String((Number(item[i])).toFixed(2))
                }
            })
        })
        finalObj['attrObj'] = attrObj
        finalObj['colorsObj'] = colorsObj
    }
    return finalObj
}

export default badgeFn


// WEBPACK FOOTER //
// ./src/utils/badgeFn.js